var TabBar = React.createClass({
  propTypes: {
    onChange: React.PropTypes.func,
    activeKey: React.PropTypes.any,
    className: React.PropTypes.string
  },
  tabClicked(key) {
    if (this.props.onChange) this.props.onChange(key);
  },
  render() {
    let {
      children,
      activeKey
    } = this.props;

    let tabs = React.Children.map(children, child => {
      return React.cloneElement(child, {
          onClick: this.tabClicked,
          active: activeKey === child.props.eventKey
        });
      }
    );

    return (
      <ul className={classNames("tab-bar", "clearfix", this.props.className)}>
        {tabs}
      </ul>
    )
  }
})